<div class="login__page">
    <div class="login">
        <div class="login__wrapper">

            @if (!authentication && !passwordExpired && !isRepeatPassword && !isEmailAuth) {
                <h2 class="login__title" [translate]="!router.url.includes('control') && !(isAdmin$ | async)
                ? 'auth.login.title' : 'auth.login.titleControl'"></h2>
                <form class="login__form" [formGroup]="form" novalidate
                >
                    <div class="login__form-item">

                        @if (!isContinue) {
                            <label class="login__form-label" [translate]="'auth.login.login'"></label>
                            <input class="login__form-input"
                                   data-testid="auth-login-email"
                                   autocomplete="username"
                                   maxlength="70"
                                   [appInputValidate]="variableValueTypeEnum.email"
                                   [placeholder]="'auth.login.email' | translate"
                                   type="text"
                                   name="email"
                                   formControlName="email"
                                   appTrimInput
                            >
                        } @else {
                            <span [ngStyle]="{fontWeight: 700}">{{ form.value.email }}</span>
                        }

                    </div>

                    @if (isContinue) {

                        <div class="login__form-item"
                        >
                            <label class="login__form-label" [translate]="'auth.login.password'"></label>
                            <input class="login__form-input"
                                   data-testid="auth-login-password"
                                   [readonly]="readOnly"
                                   autocomplete="current-password"
                                   minlength="6"
                                   maxlength="50"
                                   (focusin)="readOnly = false"
                                   [placeholder]="'auth.login.password' | translate"
                                   [type]="isVisiblePassword ? 'text' : 'password'"
                                   name="login" formControlName="password"
                                   appTrimInput
                            >
                            <div class="login__icon-eyes" (click)="isVisiblePassword = !isVisiblePassword">
                                <svg-icon
                                    [src]="!isVisiblePassword ? './assets/design/icons/eyes.svg' : './assets/design/icons/eyes-close.svg'"></svg-icon>
                            </div>
                            @if ((errorMessage$ | async) && (errorMessage$ | async).length) {
                            <p class="login__form-error">
                                <span [translate]="errorMessage$ | async"></span>
                                @if (isClickHere$ | async) {
                                <span class="login__click-here"
                                      [translate]="'auth.login.clickHere'"
                                      (click)="repeatConfirmEmail()"></span>
                                <span [translate]="'auth.login.goEmail'"></span>
                                }
                            </p>
                            }

                        </div>
                    }

                    <div class="login__form-activity">

                        @if (!isContinue) {
                        <div class="login__form-activity-item">
                            <div class="login__form-activity-column">
                                <button class="login__form-sign-btn"
                                        data-testid="auth-login-continue"
                                        autofocus
                                        [appDisabled]="{type: disabledTypeEnum.email,
                                        data: form.value.email}"
                                        (click)="isContinue = true"
                                        [translate]="'btns.continue'"></button>
                            </div>
                        </div>
                        }

                        @if (isContinue) {
                        <div class="login__form-activity-item">
                            <div class="login__form-activity-column">

                                <button (click)="backToLogin()"
                                        class="btn btn--light"
                                        [translate]="'btns.back'"
                                ></button>

                                <button class="login__form-sign-btn"
                                        data-testid="auth-login-submit"
                                        autofocus
                                        [disabled]="!isAdmin && form.touched && (!form.valid || !form.controls['password'].value.length
                                        || !form.controls['password'].valid || !form.controls['email'].valid)"
                                        [class.login__form-sign-btn--disabled]="isWaitRequest"
                                        (click)="login()"
                                        [accessKey]="'enter'"
                                        [translate]="'btns.signIn'"></button>
                            </div>
                            @if (!platform.IOS && !platform.ANDROID) {
                            <div class="login__form-activity-column">
                            <p class="login__form-forgot" data-testid="auth-login-forgot" (click)="moveForgotPage()"
                                   [translate]="'auth.login.forgot'"></p>
                            </div>
                            }

                        </div>
                        }

                        <!--                        <ng-container *ngIf="!isContinue">-->
                        <!--                            <div-->
                        <!--                                *ngIf="!platform.IOS && !platform.ANDROID && (!router.url.includes('control') && !(isAdmin$ | async))"-->
                        <!--                                class="login__form-activity-item">-->
                        <!--                                <div class="login__form-activity-column">-->
                        <!--                                    <div class="login__move login__move&#45;&#45;login">-->
                        <!--                                        <span [translate]="'auth.login.question'"></span>-->
                        <!--                                        <span (click)="moveToRegistrationPage()"-->
                        <!--                                              [translate]="'auth.login.signup'"></span>-->
                        <!--                                    </div>-->
                        <!--                                </div>-->
                        <!--                                <div *ngIf="(configurationServer$ | async)?.isGoogleAuthorization"-->
                        <!--                                     class="login__form-activity-column">-->
                        <!--                                    <p class="login__form-sign-with-title" [translate]="'auth.login.with'"></p>-->
                        <!--                                    <div class="login__form-sign-with-link" (click)="googleLogin()">-->
                        <!--                                        <svg-icon [src]="GOOGLE_LOGIN_ICON_PATH"></svg-icon>-->
                        <!--                                    </div>-->
                        <!--                                </div>-->
                        <!--                            </div>-->
                        <!--                        </ng-container>-->

                    </div>
                </form>
            }
            @if (authentication) {
                <app-authentication (closeEvent)="authentication = false"
                                    (loginEvent)="login($event)"></app-authentication>
            }

            @if (isEmailAuth) {
                <app-confirm-auth 
                [data]="loginData"
                [email]="form.value.email"
                (confirmCodeEvent)="login(null, $event)"
                (closeEvent)="closeConfirmAuth()">
                ></app-confirm-auth>
            }

            @if (isRepeatPassword && !isResetPassword) {
                <div class="expired">
                    <h1 [style.margin]="0"
                        class="expired__title" [translate]="'auth.login.repeatPassword'"></h1>
                    <div class="expired__btns">
                        <button (click)="isRepeatPassword = false" class="btn btn--light"
                                [translate]="'btns.back'"></button>
                        <button (click)="isResetPassword = true" class="btn" [accessKey]="'enter'"
                                [translate]="'btns.changePassword'"></button>
                    </div>
                </div>
            }

            @if (isResetPassword) {
                <div class="expired">
                    <app-change-password-block
                        [login]="form.value.email"
                        (passwordChangeEvent)="changePassword($event)"
                        (closeChangePasswordEvent)="isRepeatPassword = false; isResetPassword = false"
                    ></app-change-password-block>
                </div>
            }

            @if (passwordExpired && !isEmailAuth) {
                <div class="expired">
                    <h1 class="expired__title" [translate]="'auth.login.expiredTitle'"></h1>
                    <p class="expired__text" [translate]="'auth.login.expiredMessage'"></p>
                    <div class="expired__btns">
                        <button (click)="passwordExpired = false" class="btn btn--light"
                                [translate]="'btns.back'"></button>
                        <button (click)="expiredPassword()" class="btn" [accessKey]="'enter'"
                                [translate]="'btns.send'"></button>
                    </div>
                </div>
            }

        </div>
    </div>

</div>
